import { getCurrentInstance } from "vue";

export const useCurrentInstance = () => {
	const instance = getCurrentInstance();
	if (!instance) {
		throw new Error(`
      useCurrentInstance only work during setup or Lifecycle Hooks.
      Ref: https://v3.vuejs.org/api/composition-api.html#getcurrentinstance
      `);
	}

	return instance;
};
